import { Directive, HostBinding, NgModule } from '@angular/core';

@Directive({
  selector: '[systemLabel]',
})
export class LabelDirective {
  @HostBinding('class') className = 'text-sm font-medium text-gray-900 dark:text-gray-300';
  constructor() {}
}

@NgModule({
  declarations: [LabelDirective],
  exports: [LabelDirective],
})
export class SystemLabelModule {}
